import IsLdbEnabled from 'chameleon-src/utility/isLdbEnabled';
import { isMCQ } from 'chameleon-src/utility/progressHelpers';

const getInitialState = (props) => {
  const {
    isAssign = false,
    isPreApSubject,
    secureBrowserFlag,
    secureBrowserPreApFlag,
    assignment,
    assessmentWithQuestionsData: { questions },
    isGraphQLLoading = true,
    isPPC,
  } = props;
  const isNotPreAPSubjectAndNotPPC = !isPreApSubject && !isPPC;
  const ldbEnabled = IsLdbEnabled(
    secureBrowserFlag,
    secureBrowserPreApFlag,
    isPreApSubject,
  );

  return {
    isLoading: isAssign ? isGraphQLLoading : true,
    isNotPreAPSubjectAndNotPPC,
    gettingAssignmentGroups: !assignment,
    assignmentGroupsLoaded: false,
    ldbEnabled,
    isFullyMCQ: questions && questions.every(isMCQ),
  };
};

export default getInitialState;
